var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUploaderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FileUploader_Icon",
    transform: "translate(-116 -343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_345",
    "data-name": "Path 345",
    transform: "translate(116 343)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.5 39.5 L 0.5 39.5 L 0.5 0.5 L 22.40612411499023 0.5 L 25.87442016601562 3.758909940719604 L 25.87634086608887 3.760720014572144 L 25.87828063964844 3.762500047683716 L 29.5 7.094411373138428 L 29.5 39.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 1 L 1 39 L 29 39 L 29 7.313831329345703 L 25.53974914550781 4.130470275878906 L 25.53586959838867 4.126899719238281 L 25.53203010559082 4.123291015625 L 22.20806694030762 1 L 1 1 M 0 0 L 22.60416984558105 0 L 26.21680068969727 3.39453125 L 30 6.875 L 30 40 L 0 40 L 0 0 Z",
    stroke: "none",
    fill: "#10002e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M138.269,343.414l-1.487,7.157,8.79-.139",
    fill: "none",
    stroke: "#10002e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(1 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_4",
    "data-name": "Union 4",
    transform: "translate(6651.5 6976)",
    fill: "#10002e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -6519.99951171875 -6602.5 L -6522 -6602.5 L -6522 -6606 L -6522 -6606.5 L -6522.5 -6606.5 L -6524.13818359375 -6606.5 L -6520.99951171875 -6611.99267578125 L -6517.861328125 -6606.5 L -6519.49951171875 -6606.5 L -6519.99951171875 -6606.5 L -6519.99951171875 -6606 L -6519.99951171875 -6602.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -6520.49951171875 -6603 L -6520.49951171875 -6606 L -6520.49951171875 -6607 L -6519.49951171875 -6607 L -6518.72314453125 -6607 L -6520.99951171875 -6610.98486328125 L -6523.2763671875 -6607 L -6522.5 -6607 L -6521.5 -6607 L -6521.5 -6606 L -6521.5 -6603 L -6520.49951171875 -6603 M -6519.49951171875 -6602 L -6522.5 -6602 L -6522.5 -6606 L -6524.99951171875 -6606 L -6520.99951171875 -6613.00048828125 L -6517 -6606 L -6519.49951171875 -6606 L -6519.49951171875 -6602 Z",
    stroke: "none",
    fill: "#10002e"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x2: 8,
    transform: "translate(126.5 375.5)",
    fill: "none",
    stroke: "#10002e",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x2: 19,
    transform: "translate(120.5 352.5)",
    fill: "none",
    stroke: "#10002e",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x2: 15,
    transform: "translate(120.5 355.5)",
    fill: "none",
    stroke: "#10002e",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x2: 7,
    transform: "translate(120.5 358.5)",
    fill: "none",
    stroke: "#10002e",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploaderIcon);
export default __webpack_public_path__ + "static/media/FileUploader_Icon.693a00cb.svg";
export { ForwardRef as ReactComponent };